import React from "react";
import { Banner, Icon } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { areAllPassengerSirfDocsVerified } from "../../../store/selectors/sirf.js";
import styles from "./SirfWebCheckinReminder.module.css";
const SirfWebCheckinReminder = ({ order }) => {
    const i18n = useI18n();
    return (React.createElement(Banner, { className: styles.root, startIcon: React.createElement(Icon, { svg: InfoSignIcon, size: "large" }), dismissible: false }, areAllPassengerSirfDocsVerified(order)
        ? i18n.trans(t("flights_checkin_approved_message"))
        : i18n.trans(t("flights_checkin_rejected_message"))));
};
export default SirfWebCheckinReminder;
